import React, { useMemo } from 'react';
import { HeartIcon } from '@heroicons/react/24/outline';
import CloseIcon from '@heroicons/react/24/outline/XMarkIcon';
import Cart from 'components/commercetools-ui/organisms/cart-slideout';
import { Link } from 'components/commercetools-ui/organisms/header/types';
import Wishlist from 'components/commercetools-ui/organisms/wishlist';
import CartIcon from 'components/icons/cart';
import useClassNames from 'helpers/hooks/useClassNames';
import { useFormat } from 'helpers/hooks/useFormat';
import { useCart, useWishlist } from 'frontastic';
import { ImageProps } from 'frontastic/lib/image';
import CartSlideoutNew from 'components/commercetools-ui/organisms/cart-slideout/cart-slideout-new';

export type MenuState = 'cart';

export interface SlideOutProps {
  state?: MenuState;
  changeState?: (newState?: MenuState) => void;
  onClose?: () => void;
  emptyCartTitle: string;
  emptyCartSubtitle: string;
  emptyCartImage: ImageProps;
  emptyCartCategories: Link[];
  emptyWishlistTitle: string;
  emptyWishlistSubtitle: string;
  emptyWishlistImage: ImageProps;
  emptyWishlistCategories: Link[];
  enableCartState?: boolean;
  enableWishlistState?: boolean;
}

const SlideoutCart: React.FC<SlideOutProps> = ({
  state,
  onClose,
  emptyCartTitle,
  emptyCartSubtitle,
  emptyCartImage,
  emptyCartCategories,
}) => {
  const ActiveSection = useMemo(
    () =>
      ({
        cart: <CartSlideoutNew />,
      }[state as MenuState] ?? <></>),
    [emptyCartCategories, emptyCartImage, emptyCartSubtitle, emptyCartTitle, onClose, state],
  );

  return (
    <>
      <div className="pb-22 pl-12 pr-8 pt-24 md:pl-22 md:pr-18">
        <div className="flex items-center justify-between border-b border-[#d1c9c4]">
          <h3 className="text-18 font-medium leading-normal md:text-20">{'SHOPPING CART'}</h3>
        </div>
      </div>
      {ActiveSection}
    </>
  );
};

export default SlideoutCart;
